export const GET_TAG_BATCH = `
  query GetTagBatch($id: ID!) {
    getTagBatch(id: $id) {
      id
      memo
      name
      status
    }
  }
`;